import { computed, ref } from '@nuxtjs/composition-api';
import CatalogFilterItem from '@/domains/catalog/components/CatalogFilterItem.vue';


export default {
  __name: 'CatalogFilter',
  props: {
  filters: {
    type: Array,
    default: () => [],
  },
  selectedFilters: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;

const MAX_ITEMS = 5;





const isFeatureFilter = (filter) => {
  return typeof filter.id !== 'string';
};

const shouldCollapsed = computed(() => props.filters.length > MAX_ITEMS);

const isCollapsed = ref(true);

const toggleCollapse = () => {
  isCollapsed.value = !isCollapsed.value;
};

const localFilters = computed(() => {
  if (shouldCollapsed.value && isCollapsed.value)
    return props.filters.slice(0, MAX_ITEMS);
  return props.filters;
});

const collapsedCount = computed(() => props.filters.length - MAX_ITEMS);

const handleFilterChanged = ($event, name) => {
  emit('filterChanged', {
    value: $event,
    name,
  });
};

return { __sfc: true,MAX_ITEMS, props, emit, isFeatureFilter, shouldCollapsed, isCollapsed, toggleCollapse, localFilters, collapsedCount, handleFilterChanged, CatalogFilterItem }
}

}